import { render } from "./ListaCollezioni.vue?vue&type=template&id=9f7ca672"
import script from "./ListaCollezioni.vue?vue&type=script&lang=js"
export * from "./ListaCollezioni.vue?vue&type=script&lang=js"

import "./ListaCollezioni.vue?vue&type=style&index=0&id=9f7ca672&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__